export const getOcupacaoArea = (state) => state.ocupacaoArea.lista
export const getTotalOcupacaoAreas = (state) => state.ocupacaoArea.total
export const getIsCarregandoListaOcupacaoAreas = (state) => state.ocupacaoArea.isCarregandoLista
export const getOcupacaoAreaSelecionado = (state) => state.ocupacaoArea.selecionado
export const getIsCarregandoOcupacaoArea = (state) => state.ocupacaoArea.isCarregandoOcupacaoAreas
export const getIsSavingOcupacaoArea = (state) => state.ocupacaoArea.isSaving
